<template>
  <div class="main-cart__summary cart-summary critical-component-clear">
    <gift-wrap
      v-if="$variable('settings.giftWrap.enable')"
      :product="giftWrapProduct"
      class="main-cart__gift-wrap"
    />

    <div class="cart-summary__total">
      <p
        class="text-heading-m-bold-desktop text-heading-s-bold"
        v-text="$string('cart.summary.total_label')"
      />
      <p
        class="text-heading-m-bold-desktop text-heading-s-bold"
        v-text="$formatMoney(cart.total_price)"
      />
    </div>
    <div
      v-if="savings"
      class="cart-summary__total saving"
    >
      <p
        class="text-body-s"
        v-text="$string('cart.summary.save_label')"
      />
      <p
        class="text-body-s"
        v-text="$formatMoney(savings)"
      />
    </div>

    <p
      class="cart-summary__shipping text-body-s"
      v-text="$string('cart.summary.shipping_taxes_label')"
    />

    <btn
      class="cart-summary__submit"
      :label="$string('cart.checkout')"
      name="checkout"
      type="submit"
    />

    <div class="cart-summary__links">
      <a
        v-for="(link, index) of helpfulLinks"
        :key="index"
        class="text-body-m-link-desktop text-body-s-link"
        :href="link.url"
        v-text="link.title"
      />
    </div>

    <klarna-messaging
      namespace="cart-summary"
    />
  </div>
</template>

<script>

/**
 * Vue: Cart summary (main-cart)
 * -----------------------------------------------------------------------------
 * Summary of cart metrics with checkout CTA.
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'
import GiftWrap from '~async/gift-wrap/gift-wrap'
import KlarnaMessaging from '~async/klarna-messaging/klarna-messaging'

export default {
  name: 'CartSummary',

  components: {
    Btn,
    GiftWrap,
    KlarnaMessaging,
  },

  props: {
    giftWrapProduct: {
      type: Object,
      default: () => ({}),
    },
    helpfulLinks: {
      type: Array,
      default: () => [],
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Compute money saved.
     * @returns {Number}
     */
    savings() {
      let savings = 0

      this.cart.items.forEach((item) => {
        if (!item.compare_at_line_price) {
          return
        }

        const difference = item.compare_at_line_price - item.final_line_price

        if (difference <= 0) {
          return
        }

        savings += difference
      })

      return savings
    },
  },
}
</script>

<style lang="scss">
@import './cart-summary';
</style>
